<template>
  <el-dialog
    title="发布课程"
    :visible.sync="showEdit"
    width="45%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    @closed="handleClose"
    class="courseEdit"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      >
            <el-row>
              <el-col :span="14">
                <el-form-item label="大纲">
                  <love-element-upload
                    :list-type="uploadOutlineOption.listType"
                    :drag="uploadOutlineOption.drag"
                    :allow-type="uploadOutlineOption.allowType"
                    :allow-size="uploadOutlineOption.allowSize"
                    :disabled="uploadOutlineOption.disabled"
                    :limit="uploadOutlineOption.limit"
                    :multiple="uploadOutlineOption.multiple"
                    :love-path="uploadOutlineOption.lovePath"
                    :file-list="uploadOutlineOption.fileList"
                    :accept="uploadOutlineOption.accept"
                    :show-file-list="uploadOutlineOption.showFileList"
                    :tips="uploadOutlineOption.tips"
                    @preview="onOutlinePreview"
                    @remove="onOutlineRemove"
                    @success="onOutlineSuccess" />
                </el-form-item>
              </el-col>
            </el-row>
    </el-form>

    <div slot="footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">保存</axj-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = {
  main_tag_id: 0,
  school_id: 0,
  major_id: 0,
  type: 0,
  user_id: 0,
  user_name: '',
  user_avatar: '',
  author: '',
  thumb: '',
  name: '',
  lesson_sum: 0,
  homework: '',
  summary: '',
  content: '',
  address: '',
  description: '',
  source_directory: '',
  // 大纲相关
  outline_thumb: '', // 不懂这个的用处 待提问
  outline_type: '',
  outline_name: '',
  outline_url: '',
  outline_content: '', // 待提问 +1

  status: 0,
}
import {addCourses,addCourseSegment,getCourses,listCourseSegment,deleteCourseSegments,updateCourse} from '@/api/axj-help/axj-help-course.js'
export default {
  name: "course-file-edit",
  props: {
    show:{
      type:Boolean,
      default:false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    courseId:{
      type:Number,
      default:undefined
    }
  },
  data(){
    return{
      showEdit:false,
      // 记录课程唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // 学校名称
      schoolName: '',
      // 专业名称
      majorName: '',
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      },
      uploadOutlineOption: {
        listType: "text",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course/syllabus",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      },
      fileListOutline: [],
      // fileList
      fileList: {
        image: []
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        name: [
          { required: true, message: '课程标题不能为空', trigger: 'change' }
        ],
        // content: [
        //   { required: true, message: '课程标题不能为空', trigger: 'change' }
        // ],
        thumb: [
          { required: true, message: '请上传课程LOGO', trigger: 'blur,change' }
        ],
        summary: [
          { required: true, message: '课程简介不能为空', trigger: 'change' }
        ],
      },
      conforderform: {
        weekdays: [],
        index_start: [],
        index_end: [],
        address: []
      },
      options1: [{
        value: 1,
        label: '周一'
      }, {
        value: 2,
        label: '周二'
      }, {
        value: 3,
        label: '周三'
      }, {
        value: 4,
        label: '周四'
      }, {
        value: 5,
        label: '周五'
      }, {
        value: 6,
        label: '周六'
      }, {
        value: 7,
        label: '周日'
      }],
      options2: [{
        value: 1,
        label: '第一节'
      }, {
        value: 2,
        label: '第二节'
      }, {
        value: 3,
        label: '第三节'
      }, {
        value: 4,
        label: '第四节'
      }, {
        value: 5,
        label: '第五节'
      }, {
        value: 6,
        label: '第六节'
      }, {
        value: 7,
        label: '第七节'
      }, {
        value: 8,
        label: '第八节'
      }, {
        value: 9,
        label: '第九节'
      }, {
        value: 10,
        label: '第十节'
      }, {
        value: 11,
        label: '第十一节'
      }, {
        value: 12,
        label: '第十二节'
      }],
      options3: [{
        value: 1,
        label: '第一节'
      }, {
        value: 2,
        label: '第二节'
      }, {
        value: 3,
        label: '第三节'
      }, {
        value: 4,
        label: '第四节'
      }, {
        value: 5,
        label: '第五节'
      }, {
        value: 6,
        label: '第六节'
      }, {
        value: 7,
        label: '第七节'
      }, {
        value: 8,
        label: '第八节'
      }, {
        value: 9,
        label: '第九节'
      }, {
        value: 10,
        label: '第十节'
      }, {
        value: 11,
        label: '第十一节'
      }, {
        value: 12,
        label: '第十二节'
      }]
    }
  },
  methods:{
    handleOpen(){
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.uploadOption.lovePath.source_directory = this.info.id + '_' + Date.parse(new Date()) / 1000
      this.handleGetCourseData(this.courseId)
    },
    handleClose(){
      this.fileList={
        image: []
      }
      this.conforderform={
        weekdays: [],
        index_start: [],
        index_end: [],
        address: []
      }
      this.fileListOutline=[]
      this.uploadOutlineOption={
        listType: "text",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course/syllabus",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      }
      this.uploadOption= {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      }
      this.form=Object.assign({}, defaultForm)
      this.$emit("update:show",false)
    },
    handleGetCourseData(id) {
      getCourses(id)
        .then(res=> {
          const data = res.data
          this.form = Object.assign({}, this.defaultForm, data)
          // 若数据库中已经存放了该课程的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          if(this.form.outline_url!=''){
            // 整一下大纲
            this.fileListOutline.push({
              name: this.form.outline_name,
              url: this.formatUrl(this.form.outline_url)
            })
            this.uploadOutlineOption.fileList = this.fileListOutline
          }
        })
    },
    onOutlinePreview(file) {
    },
    onOutlineRemove(file, fileList) {
      this.form.outline_thumb = ''
      this.form.outline_type = ''
      this.form.outline_name = ''
      this.form.outline_url = ''
      this.form.outline_content = ''
      this.fileListOutline = []
    },
    onOutlineSuccess(response) {
      // 保存返回值
      this.form.outline_thumb = ''
      this.form.outline_type = response.file_extension
      this.form.outline_name = response.old_name
      this.form.outline_url = this.sliceUrl(response.url)
      this.form.outline_content = ''
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.fileListOutline[0] = file
      this.form.thumb = response.url
    },
    handleSubmit(status) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为课程的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          // 创建课程时
          this.handleUpdateCourse(this.form)
          this.$nextTick(()=> {
            this.$emit("updateSuccess")
          })
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleUpdateCourse(form) {
      // 修改课程内容
      this.loading = true
      updateCourse(form)
        .then(res=> {
          this.$notify({
            message: form.status == 0 ? '保存成功!' : '修改成功!',
            type: 'success',
            duration: 2000
          })
          this.loading = false
          console.log(res)
        })
        .catch(err => {
          this.$notify.error({
            message: '修改课程失败，请重试!',
            duration: 2000
          })
          this.loading = false
          console.log(err)
        })
      // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
      updateCourse({
        id: form.id,
        where: JSON.stringify({
          status: form.status,
          is_comment: form.is_comment
        })
      })
        .then(res=> {
          this.loading = false
          console.log(res)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    addlastitems(index, type) {
      if (type === '1') {
        const lastitem = this.conforderform.address[this.conforderform.address.length - 1]
        if (lastitem.trim() === ''&&this.conforderform.address.length!=1) {
          this.$message.error('请您填写完一项后继续追加')
        } else {
          this.conforderform.address.push('')
        }
      } else if (type === '2') {
        const lastitem = this.conforderform.curquesttions[this.conforderform.curquesttions.length - 1]
        if (lastitem.trim() === '') {
          this.$message.error('请您填写完一项后继续追加')
        } else {
          this.conforderform.curquesttions.push('')
        }
      } else if (type === '3') {
        const lastitem = this.conforderform.suggestions[this.conforderform.suggestions.length - 1]
        if (lastitem.trim() === '') {
          this.$message.error('请您填写完一项后继续追加')
        } else {
          this.conforderform.suggestions.push('')
        }
      }
    },
    rmlastitems(index, type) {
      this.conforderform.address.splice(index, 1)
      this.conforderform.weekdays.splice(index, 1)
      this.conforderform.index_start.splice(index, 1)
      this.conforderform.index_end.splice(index, 1)
      this.$message.success('移除成功')
    },
    handleRemoveCourseSegment(id) {
      return new Promise((resolve, reject)=> {
        deleteCourseSegments({
          where: JSON.stringify({
            course_id: id
          })
        })
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleCreateCourseSegment(id) {
      return new Promise(async (resolve, reject)=> {
        for (var i = 0; i < this.conforderform.address.length; i++) {
          let segment = {
            course_id: id,
            weekday: this.conforderform.weekdays[i],
            index_start: this.conforderform.index_start[i],
            index_end: this.conforderform.index_end[i],
            address: this.conforderform.address[i],
            start_time: 0,
            end_time: 0
          }
          await this.createCourseSegment(segment)
        }
        resolve()
      })
    },
    createCourseSegment(segment) {
      return new Promise((resolve, reject)=> {
        addCourseSegment(segment)
          .then(res=> {
            resolve(res.id)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleChangeIndexStart(val) {
      this.options3 = this.options2.filter(item=> {
        if(item.value>val) {
          return item
        }
      })
    },
    // 从后台获取到的 url 不一定都有前缀，所以通过此函数来进行判断
    formatUrl(url) {
      if(url) {
        if(!(url.indexOf('http')>=0)) {
          return this.resourcePrefix.url + url
        }
        return url
      }
    },
    sliceUrl(url) {
      if(!(url.indexOf('http')>=0)) {
        return url
      }
      return url.slice(this.resourcePrefix.url.length)
    }
  },
  created() {
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    },
  }
}
</script>

<style slot-scope lang="scss">
.course-file-edit{
  .dialog-footer{
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/course-main/component/course-file-edit/index.vue